// extracted by mini-css-extract-plugin
export default {"small":"Yp2aovOdk5nPjQ5fhVypWQ==","large":"f6T+EFIkEy3Rk8uRLu+zLw=="};